{
	"transactionCardHeader": "Validate a transaction",
	"transactionCardDescriptionBold": "You want to validate a transaction for any project?",
	"transactionCardDescriptionRegular": "If you have a transaction number at hand, you can enter it here and validate the transaction.",
	"showTransactionButton": "Show transaction",
	"transactionLabel": "Transaction number",
	"errors": {
		"transactionIdRequired": "Transaction number is required.",
		"transactionNotFound": "No transaction found.",
		"transactionIdInvalid": "Invalid transaction number."
	}
}
